/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Deleteconfirm1Inputs */

const zh_course_deleteconfirm1 = /** @type {(inputs: Course_Deleteconfirm1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认删除`)
};

const en_course_deleteconfirm1 = /** @type {(inputs: Course_Deleteconfirm1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Delete`)
};

const es_course_deleteconfirm1 = /** @type {(inputs: Course_Deleteconfirm1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar eliminación`)
};

/**
* | output |
* | --- |
* | "Confirm Delete" |
*
* @param {Course_Deleteconfirm1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_deleteconfirm1 = /** @type {((inputs?: Course_Deleteconfirm1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Deleteconfirm1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_deleteconfirm1(inputs)
	if (locale === "en") return en_course_deleteconfirm1(inputs)
	return es_course_deleteconfirm1(inputs)
});
export { course_deleteconfirm1 as "course_deleteConfirm" }